import { Box, CircularProgress } from "@mui/material";
import { useMemo } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useNavbarInitiative } from "@hooks/useNavbarInitiative";
import { CatalogEntityType, mapAggregatedType } from "../Catalog/types";
import CatalogItem from "../Catalog/components/CatalogItem";
import { useLOSearch } from "../Catalog/search/useLOSearch";
import {
  buildSearchConditions,
  LO_SORT_ORDER_BY,
} from "../Catalog/search/types";

export default function LatestTrainingOfferings() {
  const { id: corporateId = "" } = useParams();

  const navigate = useNavigate();
  const { selectedInitiative } = useNavbarInitiative();

  const conditions = useMemo(
    () =>
      buildSearchConditions({
        includeDrafts: false,
        fields: [],
        filterValues: {},
      }),
    [],
  );

  const catalogueFilters = useMemo(
    () =>
      selectedInitiative && selectedInitiative !== "all"
        ? { initiative: [Number(selectedInitiative)] }
        : undefined,
    [selectedInitiative],
  );

  const {
    items: rawItems,
    isLoading,
    mutate,
  } = useLOSearch({
    corporateId,
    conditions,
    orderBy: LO_SORT_ORDER_BY["most-recent"],
    page: 1,
    pageSize: 6,
    catalogueFilters,
  });

  const items: { entity: any; entityType: CatalogEntityType }[] = rawItems
    .filter((raw: any) => !raw.draft && raw.lo)
    .map((raw: any) => ({
      entity: raw.lo,
      entityType: mapAggregatedType(raw.type),
    }));

  const segmentForType = (type: CatalogEntityType): string =>
    type === "course" ? "courses" : type === "path" ? "paths" : "activities";

  if (isLoading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      {items.map(({ entity, entityType: itemType }) => {
        const segment = segmentForType(itemType);
        return (
          <CatalogItem
            key={`${itemType}-${entity.id}`}
            entity={entity}
            entityType={itemType}
            showDetails
            onEnrolled={mutate}
            onDetails={(e) =>
              navigate(
                `/v2/corporate/${corporateId}/detail/catalog/${segment}/${e.id}`,
              )
            }
            onPublish={(e) => {
              console.log("publish", itemType, e.id);
            }}
            onEdit={(e) =>
              navigate(
                `/v2/corporate/${corporateId}/detail/catalog/${segment}/${e.id}/edit`,
              )
            }
          />
        );
      })}
    </Box>
  );
}
